import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

/**
 * VITE_USE_MOCK=true swaps the axios adapter for an in-memory backend
 * (src/lib/mock). The whole dashboard — editor, publish flow, permissions,
 * error paths — runs without a database, which is what §10.10 asks for:
 * put the article editor in front of a marketer before the rest exists.
 */
async function boot(): Promise<void> {
  if (import.meta.env.VITE_USE_MOCK === 'true') {
    const { installMockAdapter } = await import('./lib/mock/adapter');
    installMockAdapter();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
